"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("ellipse", {
      cx: "6.71445",
      cy: "13.3307",
      rx: "5.71445",
      ry: "5.92099",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("ellipse", {
      cx: "6.85307",
      cy: "13.3309",
      rx: "2.6851",
      ry: "2.61625",
      stroke: "currentColor",
      strokeWidth: "1.2"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M11 17.252L16.1342 12.6429C18.4153 10.3618 18.4153 6.66337 16.1342 4.38226C13.8531 2.10115 10.1547 2.10115 7.8736 4.38226L3 8.75195",
      stroke: "currentColor",
      strokeWidth: "1.2"
    })]
  });
};

exports.default = Icon;